<template>
  <div>
    <div class="controls">
        <el-button type="primary" @click="openReservationEditor"  size="small"><span class="hidden-md-and-down">{{$t('reservation.newReservation')}}</span><i class="el-icon-plus hidden-lg-and-up"></i></el-button>
    </div>
    <div class="hidden-md-and-down">
      <reservationTable  :showCustomer="false" :reservations="getActiveCustomerReservations" :loading="loading" @delete="handleDelete" @edit="editReservation" :height="500"></reservationTable>
    </div>
    <div class="hidden-lg-and-up mobile-reservations-container">
      <h5>{{$t('reservation.reservations')}}</h5>
      <el-divider/>
      <div v-for="(r, index) in customerReservations" :key="r.id">
        <ReservationTile
          :ctrlFlipBoard="true"
          @edit="editReservation(r)"
          @delete="handleDeleteReservation(r)"
          @confirm="handleConfirmReservation(r)"
          :reservation="r"
          :showSalesRep="r.sales_rep!=null" />
        <el-divider />
      </div>
      <div v-if="customerReservations.length==0" style="text-align:center">
          <span  class="secondary-text fs-14">{{$t('reservation.noReservation')}}</span>
      </div>

    </div>
    <ReservationEditor :visible="reservationCreatorVisible" :customerId="customerId" :edit="reservationToEdit" @close="closeReservationEditor" @created="updateCustomerReservation" @updated="updateCustomerReservation"></ReservationEditor>
  </div>
</template>
<script>
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';
import reservationTable from '@/components/dashboards/reservation/reservation-table'
import ReservationEditor from '@/components/reservation/reservation-editor'
import ReservationTile from '@/components/reservation/reservation-tile'
import reservationAPI from '@/services/API/reservation';

export default {
  name: 'customer-reservation',
	props: {
    customerId : {
      type : String,
      default : null
    }
	},
  data() {
    return {
      reservationCreatorVisible : false,
      reservationToEdit : null,
      ctrlReservationId : null
    };
  },components: {
    reservationTable,
    ReservationEditor,
    ReservationTile
  },
  watch : {
    customerId : function(newVal, oldVal){
      if(newVal!=oldVal){
        this.fetchCustomerReservations({customerId:this.customerId, paging:'no'});
      }
    }
  },
	methods: {
    handleConfirmReservation(r){
      this.$message.warning("Cette fonctionnalité n'est pas encore disponible");
    },
    handleDeleteReservation(r){
      this.deleteCustomerReservation({customerId : r.fk_customer_id, reservationId : r.id})
    },
    updateCustomerReservation(){
      this.fetchCustomerReservations(parseInt(this.customerId));
    },
    closeReservationEditor(){
			this.reservationCreatorVisible=false;
      this.reservationToEdit=null;
		},
		openReservationEditor(){
			this.reservationCreatorVisible=true;
		},
    _diffDate(dateTimeFrom, measure='days',dateTimeToDefault=null){
      let dateTimeTo = dateTimeToDefault==null?moment():moment(dateTimeTo, measure);
      return moment(dateTimeFrom).diff(dateTimeTo, measure);
    },
    formatNbJours(nbJours){
      if(nbJours==0){
        return "Aujourd'hui";
      }else{
        if(nbJours<0) return (nbJours*-1)+ " jours";
        return nbJours+ " jours";
      }
    },
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);
    },
    handleDelete(reservationId){
      this.$confirm("Ceci supprimera définitivement la réservation du système. Continuer?", 'Attention', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(() => {
          this.deleteCustomerReservation({reservationId, customerId : this.customerId})
            .then(()=>{
              this.$message({
                type: 'success',
                message: "Réservation supprimée"
              });
            }).catch(err=>{
              this.$message({
                type: 'error',
                message: "Une erreur système s'est produit. Veuillez réessayer plus tard"
              });
            })

        }).catch(() => {});

    },
    editReservation(reservation){
      this.reservationToEdit=reservation;
      this.openReservationEditor();
    },
    salesRepFirstName(r){
      return r.sales_rep!= null ? r.sales_rep.first_name :  null;
    },
    salesRepLastName(r){
      return r.sales_rep!= null ? r.sales_rep.last_name :  null;
    },
    ...mapActions('reservations', ['fetchCustomerReservations','deleteCustomerReservation']),
	},
	computed: {

    ...mapGetters('reservations',['isPositive','isNegative','isIntermediary','isActive','customerName', 'getActiveCustomerReservations','isQuantityValid']),
    ...mapState('reservations', ['customerReservations', 'loading'])

	},
  mounted(){
    this.fetchCustomerReservations(parseInt(this.customerId));
  }
}
</script>
<style lang="scss" scoped>

.controls{
	position:relative;
	height:30px;
  margin-bottom:20px;
	button{
    float:right;
		margin-left:20px;
    margin-top:10px;
	}
}

@media (max-width: 1199px) {
  .mobile-reservations-container {
    padding-bottom: 24px;
  }
}

</style>
